import get from 'lodash.get'
import StudentInformationService from '../../../services/StudentInformationService'
import { ASR_EVENTS } from '../StudentASRChecks/StudentASRConstants'

export default function handlePreCheckEvents(eventName, listenerApi){
    const states = listenerApi.getState()
    const studentId = get(states, 'studentPreChecks.settings.sessionData.userId', '')

    console.log("handling ready module event", eventName, studentId)

    if(eventName === ASR_EVENTS.FLAG_HARD_TO_UNDERSTAND){
        try{
            StudentInformationService.setHardToUnderstand(studentId, true)
        }catch(err){
            console.log("error flagging student true", err)
        }
    }else if(eventName === ASR_EVENTS.SKIP_FLAG_HARD_TO_UNDERSTAND){
        try{
            StudentInformationService.setHardToUnderstand(studentId, false)
        }catch(err){
            console.log("error flagging student false", err)
        }
    }
}